import axios from 'axios';

/**
 * GET /schedules. The reply shape is unconfirmed: docs/API.md says a list,
 * `useGetScheduleQueries` reads one `{ threshold, id }` (roadmap follow-up).
 * @param {string} deviceId
 * @param {'ESS'|'TGS'|'TES'} deviceType
 * @returns {Promise<*>}
 */

export const getScheduleForDeviceService = async (deviceId, deviceType) => {
  const response = await axios.get(`/schedules?deviceId=${deviceId}&deviceType=${deviceType}`);
  return response.data?.data;
};

/**
 * POST /schedules/. The UI reads only `id` from the reply.
 * @param {import('../helpers/payloads/schedulePayload').SchedulePayload} data
 * @returns {Promise<{id: string}>}
 */

export const createScheduleService = async (data) => {
  const response = await axios.post('/schedules/', data);
  return response.data;
};

/**
 * PATCH /schedules/{id}, same body as create.
 * @param {string} id
 * @param {import('../helpers/payloads/schedulePayload').SchedulePayload} data
 * @returns {Promise<{id: string}>}
 */

export const updateScheduleService = async (id, data) => {
  const response = await axios.patch(`/schedules/${id}`, data);
  return response.data;
};

/** DELETE /schedules/{id}. @param {string} id @returns {Promise<*>} */

export const deleteScheduleService = async (id) => {
  const response = await axios.delete(`/schedules/${id}`);
  return response.data;
};
